import PercentRegistrationPage from './PercentRegistrationPage';

export default PercentRegistrationPage;
